<div *ngIf="isCxOne" class="row back-button color-whaleTail h-100">
    <!--Shopping Cart Window Cxone-->
    <sol-spinner [hidden]="!loading" class="marketplace-loader" [showSpinner]="true"></sol-spinner>
    <div id="shopping-cart-container-header" class="col-12"
        *ngIf="!loading && pscs?.pointStoreCart.pointStoreProducts.length > 0">
        <div class="shopping-cart-header-back" [hidden]="pscs.pointStoreVisibleContent.showCheckoutMessage">
            <label class="back-btn" (click)="goToBrowse()" cvLocalizedText langSection="MarketPlace"
                langKey="Back_to_Results">Back to results</label>
        </div>
        <div class="shopping-cart-header-total mb-3" [hidden]="pscs.pointStoreVisibleContent.showCheckoutMessage">
            <span class="shopping-cart-my-cart-text jerseyDevil" cvLocalizedText langSection="MarketPlace"
                langKey="My_Cart">My Cart</span>
            <span class="shopping-cart-products-quantity">({{getCartProductsWithoutQuantity()}} </span>
            <span class="text-lowercase" cvLocalizedText langSection="MarketPlace" langKey="Products" [hidden]="!(getCartProductsWithoutQuantity() > 1)">Products</span>
            <span class="text-lowercase" cvLocalizedText langSection="MarketPlace" langKey="Product" [hidden]="(getCartProductsWithoutQuantity() > 1)">Product</span>)           
        </div>
    </div>
    <div id="shopping-cart-container-body" class="col-12 h-100" style="margin-top: 40px;"
        [hidden]="pscs.pointStoreVisibleContent.showCheckoutMessage || pscs?.pointStoreCart.pointStoreProducts.length == 0">
        <ag-grid-angular 
            #shoppingCardListGrid
            id="cart-grid"
            *ngIf="gridOptions && !pscs.pointStoreVisibleContent.showCheckoutMessage && pscs.pointStoreVisibleContent.showShoppingCartPage"
            class="ag-theme-balham flex-fill" [gridOptions]="gridOptions"
            [components]="components"></ag-grid-angular>

    </div>
    <div id="shopping-cart-container-footer" class="col-12"
        *ngIf="!loading && pscs?.pointStoreCart.pointStoreProducts.length > 0"
        [hidden]="pscs.pointStoreVisibleContent.showCheckoutMessage">
        <div class="row h-100">
            <div class="col-6 rmv-mr">
                <div id="shopping-cart-footer-content-left">
                    <div *ngIf="isNoLongerAvailableItems()">
                        <svg id="cxone-warning-icon-no-longer-available">
                            <use href="../App_Themes/CXone/icons/no-longer-available.svg#no-longer-available"></use>
                        </svg>  
                    </div>
                    <div *ngIf="isNoLongerAvailableItems()">
                        <p id="cxone-warning-text-no-longer-available" cvLocalizedText langSection="MarketPlace" langKey="These_Products_Are_Not_Longer_Available">
                            These products are no longer available.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-6 rmv-ml text-right">
                <div id="shopping-cart-footer">
                    <div id="shopping-cart-footer-lt">
                        <span>{{getLocalizationString("Total_Price", "Total Price")}} </span>
                        <span class="shopping-cart-products-quantity">
                            ({{getCartTotalQuantity()}}
                            <span class="text-lowercase font-weight-normal" cvLocalizedText langSection="MarketPlace" 
                            langKey="Products" [hidden]="!(getCartTotalQuantity() > 1)"> Products</span>
                            <span class="text-lowercase font-weight-normal" cvLocalizedText langSection="MarketPlace" 
                            langKey="Product" [hidden]="(getCartTotalQuantity() > 1)"> Product</span>):
                        </span>
                        <span class="font-weight-bold">{{cvNumberLocalize.transform(getTotal())}}</span>
                        <span class="text-lowercase font-weight-bold">{{cvNumberLocalize.transform(getTotal()) == 1 ? getLocalizationString("Coin", "Coin") : getLocalizationString("Coins", "Coins")}}</span>
                    </div>
                    <div id="shopping-cart-footer-cr" *ngIf="isTotalPriceLargerThanNumberCoins()">
                        <svg id="cxone-warning-two-icon-no-longer-available"
                            tooltip='{{this.getLocalizationString("Your_Balance_Is_Less_Than_The_Price_Selected_Products",
                            "Your balance is less than the price of selected products")}}'                     
                            containerClass='marketplace-tooltip-balance-warning'                                   
                            placement="top">
                            <use href="../App_Themes/CXone/icons/warning-no-longer-available.svg#warning-no-longer-available"></use>
                        </svg>
                    </div>
                    <div id="shopping-cart-footer-rt">
                        <button type="button" class="btn btn-primary" [disabled]="!enableCheckout()"
                            (click)="enableCheckout() ? checkOut() : null">
                            <span cvLocalizedText langSection="MarketPlace" langKey="Checkout">Checkout</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- order placed -->
    <cv-cxone-order-placed  class="col-12 w-100" 
                            [hidden]="!pscs.pointStoreVisibleContent.showCheckoutMessage"></cv-cxone-order-placed>


    <!-- empty state -->
    <div id="shopping-cart-container-body-empty-state" class="col-12"
        *ngIf="!loading && pscs?.pointStoreCart.pointStoreProducts.length == 0"
        [hidden]="pscs.pointStoreVisibleContent.showCheckoutMessage">
        <div id="shopping-cart-container-body-empty-state-header">
            <span class="shopping-cart-my-cart-text" cvLocalizedText langSection="MarketPlace" langKey="My_Cart">My
                Cart</span>
        </div>
        <div id="shopping-cart-container-body-empty-state-container">
            <div>
                <svg>
                    <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                </svg>
            </div>
            <div>
                <p class="shopping-cart-container-body-empty-state-text">{{this.getLocalizationString("Empty_Cart",
                    "Your cart is empty")}}</p>
            </div>
            <div>
                <button type="button" class="btn btn-text btn-keep-shopping" (click)="goToBrowse()">
                    <span cvLocalizedText langSection="MarketPlace" langKey="Keep_Shopping">Keep Shopping</span>
                </button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isCxOne" class="row back-button color-whaleTail h-100 cv-container">
    <!--Shopping Cart Window-->
    <cv-loader [hidden]="!loading"></cv-loader>
    <div id="shopping-cart-container-header" class="col-12">
        <div class="shopping-cart-header-back" *ngIf="!loading">
            <svg class="icon-16 fill-whaleTail cursor-pointer">
                <use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use>
            </svg>
            <label class="cursor-pointer" (click)="goToBrowse()" cvLocalizedText langSection="MarketPlace"
                langKey="Back_to_Browse">Back to Browse</label>
        </div>
    </div>
    <div id="shopping-cart-container-body" class="col-12 h-100" style="margin-top: 40px;"
        [hidden]="pscs.pointStoreVisibleContent.showCheckoutMessage">
        <ag-grid-angular #shoppingCardListGrid id="cart-grid"
            *ngIf="gridOptions && !pscs.pointStoreVisibleContent.showCheckoutMessage && pscs.pointStoreVisibleContent.showShoppingCartPage"
            class="ag-theme-balham flex-fill" [gridOptions]="gridOptions"
            [components]="components"></ag-grid-angular>
    </div>
    <div id="shopping-cart-container-footer" class="col-12" *ngIf="!loading"
        [hidden]="pscs.pointStoreVisibleContent.showCheckoutMessage">
        <div class="row h-100">
            <div class="col-12 text-right">
                <div id="shopping-cart-footer">
                    <div id="shopping-cart-footer-lt">
                        <span>{{getLocalizationString("Total_Price", "Total Price")}}: </span>
                        <svg class="icon-24 fill-bananaSlug">
                            <use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use>
                        </svg>
                        <span style="font-weight: bold;margin-left: 5px;">{{cvNumberLocalize.transform(getTotal())}} </span>
                        <span style="margin-left: 4px;font-weight: bold;">{{cvNumberLocalize.transform(getTotal()) == 1 ? getLocalizationString("Coin", "Coin") : getLocalizationString("Coins", "Coins")}}</span>
                    </div>
                    <div id="shopping-cart-footer-rt">
                        <button type="button" class="btn btn-primary" [disabled]="!enableCheckout()"
                            (click)="enableCheckout() ? checkOut() : null">
                            <span cvLocalizedText langSection="MarketPlace" langKey="Checkout">Checkout</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row w-100" style="height: calc(100% - 140px);"
        [hidden]="!pscs.pointStoreVisibleContent.showCheckoutMessage">
        <div class="shopping-cart-checkout col-12">
            <div class="cart-checkout-completed">
                <img class="checkout-icon-completed"
                    src="../App_Themes/Standard/Images/AgentOrderHistory/checkout.svg" />
                <h1 class="lato-bold font-size-18 color-whaleTail"><span cvLocalizedText langSection="MarketPlace"
                        langKey="Thank_You">Thank you!</span></h1>
                <span class="font-size-14 color-valyrianSteel" cvLocalizedText langSection="MarketPlace"
                    langKey="Order_Has_Been_Placed">Your order has been placed, you can check your order status in the
                    Orders tab.</span>
            </div>
            <div class="shopping-cart-empty-actions">
                <div class="btn-keep-shopping" (click)="goToBrowse()"><span cvLocalizedText langSection="MarketPlace"
                        langKey="Keep_Shopping">Keep Shopping</span></div>
                <div class="btn-view-orders" (click)="goToOrders()"><span cvLocalizedText langSection="MarketPlace"
                        langKey="View_Orders">View Orders</span></div>
            </div>
        </div>
    </div>
</div>
